import { get, post } from '../lib/apiClient';

/**
 * POST /proof-of-funds — submit for review.
 * { documents: [{ fileId, fileName? }], declaredAmount, currency, source? }
 * Documents are financial PII; the backend audit-logs every reviewer access.
 */
export const submitProof = (payload) => post('/proof-of-funds', payload);

/** GET /proof-of-funds/mine — caller's own submissions, paginated */
export const listMine = (query) => get('/proof-of-funds/mine', { query });

/**
 * GET /proof-of-funds — review queue (reviewer role only), filtered by
 * `status` (pending | under_review | verified | rejected | expired;
 * default pending).
 */
export const listQueue = (query) => get('/proof-of-funds', { query });

/** GET /proof-of-funds/{proofId} */
export const getProof = (proofId) => get(`/proof-of-funds/${encodeURIComponent(proofId)}`);

/** POST /proof-of-funds/{proofId}/claim — reviewer claims a submission */
export const claimProof = (proofId) =>
  post(`/proof-of-funds/${encodeURIComponent(proofId)}/claim`);

/**
 * POST /proof-of-funds/{proofId}/review — { decision: 'approve'|'reject',
 * reviewNotes? }. Approval is the ONLY path that upgrades a user to
 * accredited-investor (platform invariant). Self-review is forbidden.
 */
export const reviewProof = (proofId, payload) =>
  post(`/proof-of-funds/${encodeURIComponent(proofId)}/review`, payload);
